import { Component, OnInit, Input, Output, EventEmitter, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { scaleIn, slideMenu, slideIn, fadeInOut } from '../../shared/animations/modal.animation';
import { Auth } from 'aws-amplify';
import { PropertyValuationService } from 'src/app/shared/services/property-valuation.service';

@Component({
  selector: 'app-view-more',
  templateUrl: './view-more.component.html',
  styleUrls: ['./view-more.component.css'],
  animations: [scaleIn, slideMenu, slideIn, fadeInOut]
})
export class ViewMoreComponent implements OnInit {

  _property: any;
  username: string;
  isHidden: boolean;
  userLoggedIn: boolean;
  userGroup: any;
  successMessage: string;

  @Input()
  get property(): any { return this._property; }
  set property(eventProperty: any) {
    this._property = eventProperty;
    console.log("View User", this._user);
    console.log("Received Propery:", this.property);
    if(this._user && this.property){
      if(this._user.attributes.sub === this.property._source.sub){
        this.isVisible = true;
      }else{
        this.isVisible = false;
      }
    }
  }

  public isVisible: boolean = false;

  _user: any;
  @Input()
  get user(): any{ return this._user; }
  set user(cognitoUser: any) {
    this._user = cognitoUser;
    console.log("Recieved User: ", this.user);
    
  }

  @Input() visible = false; 
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  public displayTier = false; 
  public imageBaseUrl = "https://ganisponsormarket-all-purpose.s3.amazonaws.com/";
  public isLoading: boolean = false;
  
  constructor(@Inject(DOCUMENT) private document: any, private valuationService: PropertyValuationService) {
  }

  ngOnInit() {
  console.log("View More ngOnInit");
    this.getCurrentAuthenticatedUser(); 
  }

  onEvaluate(property: any){
    console.log("Property: ", property);
    
    this.isLoading = true;
    this.valuationService.requestPropertyEvaluation(property).subscribe((data) => {
      
      console.log(data);

      const valuationObj = {
        propName: property._source.propName
      }

      this.sendValuationNotification(valuationObj);
      
    }, (error) => {
      this.isLoading = false;
      console.log("Error requesting Property Evaluation", error);
    });
  }

  sendValuationNotification(propertyObject: any){
    
    this.valuationService.sendValuationNotification(propertyObject).subscribe((data) => {
      this.isLoading = false;
      this.successMessage = "You have successfully submited a request to Evaluate your property, you can check the progress of your evaluation under Evaluations page";
      console.log("Valuation: ", data);
    }, (error) => {
      this.isLoading = false;
      console.log("Valuation Notification Error: ", error);
    })
  }

  getCurrentAuthenticatedUser() {
    const user = Auth.currentAuthenticatedUser()
      .then((user) => {
        this.username = user.attributes.name + " " + user.attributes.family_name;
        this.isHidden = false;
        this.userLoggedIn = true;

        this.userGroup = user.signInUserSession.accessToken.payload['cognito:groups'][0];
        // console.log('Detailed user group data ==> ', user.signInUserSession.accessToken.payload['cognito:groups'][0]);
        // console.log('header user', user);
        // console.log('userLoggedIn value is :: ', this.userLoggedIn);
        

      },
        (error) => {
          // console.log("authentication error", error);

          this.isHidden = true;
        });
  }

  close() {
    this.successMessage = "";
    this.document.body.style.overflow = 'visible';
    this.visible = false;
    this.visibleChange.emit(this.visible);
    setTimeout(() => {
    }, 1000);
  }

  log(){
    // console.log("View More: ", this.property);
  }

  show(): void {
    console.log("SHOW");
    this.document.body.style.overflow = 'hidden';
    this.visible = true;
  }

  // onShowEvaluate(){
  //   this.visible1 = false; 
  //   this.evaluate_visible = true; 
  // }

  onDisplayTier(){
    this.displayTier = true; 
    this.close()
  }

}
